<template>
<div class="container">
    <div class="row h-50">
        <div v-if="loading" class="row d-flex justify-content-center align-middle my-4">
            <circle8></circle8>
            <h3>Loading magical things :)</h3>
        </div>
        <div v-if="error" class="row d-flex my-4 mx-4">
            <h2 class="text-danger">
                There was an error. Please check that you entered the email and
                password correctly.
            </h2>
        </div>
        <div v-if="tokens" class="row d-flex my-4 mx-4">
            <div class="col">
                <vue-json-pretty :path="'res'" :data="tokens" class="tokenOutput">
                </vue-json-pretty>
            </div>
            <div class="col">
                <h4>Access Token</h4>
                <p class="specialPara">{{ accessToken }}</p>
                <label class="message" for="vin">VIN</label>
                <input class="form-control my-2" id="vin" v-model="vin" type="text" name="vin" />
                <div class="py-3" style="text-align: center">
                    <button class="ty-button" v-on:click="registerVehicle">Register VIN</button>
                </div>
                <p>{{registerVehicleResponse}}</p>
            </div>
            <div class="col">
                <h2>Decoded Access Token</h2>
                <vue-json-pretty :path="'res'" :data="decodedAccessToken" class="tokenOutput">
                </vue-json-pretty>
            </div>
            <div class="col">
                <h2>Decoded ID Token</h2>
                <vue-json-pretty :path="'res'" :data="decodedIDToken" class="tokenOutput">
                </vue-json-pretty>
            </div>
            <div class="py-3" style="text-align: center">
                <button class="ty-button" v-on:click="restart">Restart</button>
            </div>
        </div>
        <div class="col-8 offset-2 my-4" v-else>
            <h2 class="message">
                Need to register a 21MM vehicle on Toyota, Lexus or Subaru QA or STG?
            </h2>
            <p>
                1. Enter your username (email) and password. 2. If it worked, enter your VIN number. 3. Celebrate
            </p>
            <p>
                <label class="message" for="username">UserName (email)</label>
                <input class="form-control my-2" id="username" v-model="username" type="text" name="email" />
                <label class="message" for="password">Password</label>
                <input class="form-control my-2" id="password" v-model="password" type="text" name="password" />
                <label class="message" for="selected">Select an Environment</label>
                <select class="form-select my-2" aria-label="Select an environment" v-model="selected">
                    <option selected>Select an environment</option>
                    <option value="QA">QA</option>
                    <option value="STG">STG</option>
                </select>
                <label class="message" for="selectedBrand">Select the App Brand</label>
                <select class="form-select my-2" aria-label="Select an environment" v-model="selectedBrand">
                    <option selected>Select an app brand</option>
                    <option value="TOYOTA">TOYOTA</option>
                    <option value="LEXUS">LEXUS</option>
                    <option value="SUBARU">SUBARU</option>
                </select>
            </p>
            <div class="py-3" style="text-align: center">
                <button class="ty-button" v-on:click="requestToken">Submit</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import jwt_decode from "jwt-decode";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
    name: "regvehicle",
    data: function () {
        return {
            error: false,
            username: null,
            password: null,
            selected: "QA",
            selectedBrand: "TOYOTA",
            tokens: null,
            accessToken: null,
            decodedAccessToken: null,
            decodedIDToken: null,
            loading: false,
            vin: null,
            registerVehicleResponse: null,
        };
    },
    components: {
        VueJsonPretty,
    },
    methods: {
        requestToken: function () {
            this.error = false;
            this.loading = true;
            const data = JSON.stringify({
                username: this.username,
                password: this.password,
                environment: this.selected,
                brand: this.selectedBrand,
            });
            if (!this.username || !this.username) {
                this.loading = false;
                alert(
                    "Please enter valid values for username and password.  Thank you!"
                );
                return;
            }
            const config = {
                method: "post",
                url: "https://0ux1ynokc6.execute-api.us-west-2.amazonaws.com/dev/frnative",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                data: data,
            };

            this.axios(config)
                .then((response) => {
                    this.loading = false;
                    console.log("Access Token: ", response);
                    console.log(JSON.stringify(response.data));
                    if (
                        !response.data.body.access_token &&
                        !response.data.body.id_token
                    ) {
                        throw "There was an issue.  Please verify you have the right email and password.";
                    }
                    this.tokens = JSON.stringify(response.data.body);
                    this.accessToken = response.data.body.access_token;
                    this.decodedAccessToken = jwt_decode(response.data.body.access_token);
                    this.decodedIDToken = jwt_decode(response.data.body.id_token);
                })
                .catch((error) => {
                    this.error = true;
                    this.loading = false;
                    if (error.response) {
                        console.log(error.response);
                        if (error.response.data.kind) {
                            alert(`Well that was unexpected.  ${error.response.data.kind}`);
                        } else {
                            alert(`Well that was unexpected.  ${error.response.data}`);
                        }
                    }
                });
        },
        registerVehicle: function () {
            // eslint-disable-next-line no-console
            const config = {
                method: "post",
                url: "https://5qh76zfwkl.execute-api.us-east-1.amazonaws.com/staging/govrs",
                headers: {
                    //'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${this.accessToken}`,
                    "x-vin": this.vin,
                    "x-env": this.selected,
                },
            };

            this.axios(config)
                .then((response) => {
                    // eslint-disable-next-line no-console
                    console.log("Register Vehicle Response:", response.data);
                    // this.addLog(
                    //     "Register Vehicle Response: " + JSON.stringify(response, null, 2)
                    // );
                    if (response.data) {
                        this.registerVehicleResponse = response.data;
                    }
                })
                .catch((error) => {
                    // eslint-disable-next-line no-console
                    console.log("Register Vehicle Error:", error);
                    this.registerVehicleResponse = error.message;
                });
        },
        restart: function () {
            this.error = false;
            this.username = null;
            this.password = null;
            this.selected = "QA";
            this.selectedBrand = "TOYOTA";
            this.tokens = null;
            this.decodedAccessToken = null;
            this.decodedIDToken = null;
        },
    },
};
</script>

<style scoped>
a {
    color: #42b983;
}

.ty-button {
    background: #eb0a1e;
    width: 320px;
    height: 56px;
    font-family: ToyotaType-Semibold, sans-serif;
    font-size: 24px;
    color: #ffffff;
    letter-spacing: 1px;
    text-align: center;
    border-radius: 70px;
}

.tokenOutput {
    text-align: left !important;
}

.specialPara {
    word-wrap: break-word;
    text-align: left !important;
}
</style>
